import React, { Component } from 'react';
import axios from 'axios';
import { withRouter, Link } from 'react-router-dom';
import constClass from '../../Constants/Constants';
import Loading from '../Loading/Loading';
import util from 'util';
import moment from 'moment';
import 'moment/locale/ja';
import Common from '../Common/common';
import CommonBooking from '../Common/common_booking';
import ScrollToTop from '../Scroll/ScrollToTop';

import Payment from '../Payment/Payment';
import BookingQRRead from './BookingQRRead';
import BookingCancel from './BookingCancel';
import BookingDetailView from './BookingDetailView';

import ReceptImg from '../Images/recept.svg';

class Booking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sleeping: false,
      ready: false,
      disabled: false,
      siteId: isFinite(this.props.siteId) ? this.props.siteId : 0,
      book_id: null,
      book_set_id: null,
      categoryMaster: null,
      bookDateList: null,
      bookingList: null,
      shoplist: [],
      arealist: [],
      selectarealist: '',
      shopcahge: true,
      talklist: [],
      card_id: '',//会員番号
      customer_after_select: true,
      set_booking: {
        book_id: null,
        book_date: null,
        total: 0,
        customer_id: null,
        customer_name: '',
        customer_kana: '',
        customer_address: '',
        customer_address_number: '',//郵便番号
        customer_address1: '',//県
        customer_address2: '',//市町村
        customer_address3: '',//番
        customer_phone: '',//電話番号
        customer_mobilephone: '',//携帯電話番号
        customer_gender: '',
        talk_id: '',
        talktext: '',
        connect_means: '',
        customer_before_time: '',
        customer_after_time: '',
        staff_name: '',
        customer_age_type: '',
        privacy_policy: constClass.FLAG.OFF,
      },
      set_booking_detail: [],
      set_bookCalList: null,
      set_bookCalListMessage: null,
      my_customer: {
        customer_id: null,
        card_id: '',
        customer_name: '',
        customer_kana: '',
        customer_address_number: '',//郵便番号
        customer_address1: '',//県
        customer_address2: '',//市町村
        customer_address3: '',//番
        customer_phone: '',//電話番号
        customer_mobilephone: '',//携帯電話番号
        customer_gender: '',
        birthdayy: '',
        birthdaym: '',
        birthdayd: '',
      },
      selectdata: {
        birthdayy: '',
        birthdaym: '',
        birthdayd: '',
      },

      bookCalList: null,
      bookCalListMessage: null,
      recept: null,
      change: false,
      user_modal_flag: false,
      user_modal_read: false,
      bookingDetailList: null,
      cancel_modal_flag: false,
      payment_data: {},
    }
    this.modalStyle = {
      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: "rgba(0,0,0,0.5)"
      },
      content: {
        position: "absolute",
        left: '0.5rem',
        right: '0.5rem',
        top: '50%',
        bottom: 'auto',
        marginTop: '-25%',
        borderRadius: "0rem",
        padding: "0px",
        height: "auto"
      }
    };
    this.setReady = this.setReady.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.refreshBookData = this.refreshBookData.bind(this);
    this.backPayment = this.backPayment.bind(this);
    this.returnPayment = this.returnPayment.bind(this);
    this.submitCurrentbooking = this.submitCurrentbooking.bind(this);
    this.pageRef = React.createRef();
  }
  setReady() {
    if (this.state.bookDateList !== null && this.state.categoryMaster !== null) {
      this.setState({ ready: true });
    } else {
      this.setState({ ready: false });
    }
  }
  async refreshData() {
    if (process.env.REACT_APP_ENV !== 'dev') {
      await window.liff.ready;
    }
    if (!this.props.liff_access_token) {
      if (!this.intervalMaster) {
        this.intervalMaster = setInterval(() => {
          this.refreshData();
        }, 500);
      }
    } else {
      clearInterval(this.intervalMaster);
      try {
        const params = {
          site_id: this.state.siteId,
          line_id: this.props.liff_access_token,
        }
        if ((("CONTRACT_PERIOD_STARTTIME" in this.props.settings) && parseInt(this.props.settings.CONTRACT_PERIOD_STARTTIME) > parseInt(moment().format('YYYYMMDDkkmm')))) {
          this.props.history.replace(`/${this.state.siteId}/`);
        }
        const calendarPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/calendar/listdate/${this.state.siteId}`);
        const customerPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/search/line`, params);
        const month = ("BOOKING_DATE_LIMIT_MONTH" in this.props.settings) ? parseInt(this.props.settings.BOOKING_DATE_LIMIT_MONTH) : 1;
        var bookDateList = (await calendarPromise).data.filter(x => moment(x.book_date).isBefore(moment().add(month, "month").subtract(1, "day")));//翌月の1日前先まで予約可能
        const limit = Common.getSettingValue(this.props.settings, "BOOKING_LIMIT", "0");
        if (limit && !Number.isNaN(limit) && Number(limit) > 0) {
          const limit_unit = Common.getSettingValue(this.props.settings, "BOOKING_LIMIT_UNIT", "m");
          const limitDate = moment().add(limit, limit_unit);
          bookDateList = bookDateList.filter(x => moment(x.book_date).isSameOrAfter(limitDate, 'day'));
        }
        const customer = (await customerPromise).data;

        //会員情報の性別を変換
        if (customer && customer.data) {
          customer.data.customer_gender = (customer.data.customer_gender || customer.data.customer_gender === 0) ? constClass.API_CUSTOMER_GENDER[customer.data.customer_gender] : '';
        }
        await this.getCategoryList(null);
        await this.getSelectShop();
        await this.getSelectArea();
        await this.getSelectTalk();
        this.setState({
          bookDateList,
          my_customer: customer.data ? customer.data : this.state.my_customer,
        });
        await this.refreshBookData();
        //決済入力画面の場合は、submitPaymentを実行
        if (this.props.page === constClass.PAYMENT && isFinite(this.props.current_bookId)) {
          this.submitPayment(this.props.current_bookId);
        }
      } catch (error) {
        console.log(error);
        this.setState({ sleeping: true });
      }
    }
    this.setReady();
  }

  async refreshBookData() {
    const book_id = isFinite(this.props.current_bookId) ? this.props.current_bookId : null;
    const book_set_id = isFinite(this.props.current_bookSetId) ? this.props.current_bookSetId : null;
    const params = {
      site_id: this.state.siteId,
      line_id: this.props.liff_access_token
    }
    const bookingPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/search_detail/`, params);
    const bookingDetailList = (await bookingPromise).data;
    var my_customer = this.state.my_customer;
    var booking = null;
    var booking_detail = [];
    var booked = null;
    var callist = this.state.bookCalList;
    var recept = await this.getReceptdata(bookingDetailList);
    var selectarealist = '';
    if (book_id) {
      var detail = await bookingDetailList.filter(x => (Number(x.book_id) === Number(book_id)));
      await Promise.all(detail.map(async (item) => {
        callist = await this.getCalendarchang(item, item, detail);
        callist.forEach((item2, idx) => {
          if (item2.category_id === item.category_id && item2.start_time === item.start_time) {
            callist[idx] = { ...item2, bookok_count: item2.bookok_count + item.count }
          }
        });
        const errmsg = (item.category_id && item.start_time && callist.findIndex(x => x.category_id === item.category_id && x.start_time === item.start_time) < 0)
          || (item.category_id && item.start_time && callist.findIndex(x => x.category_id === item.category_id && x.start_time === item.start_time) >= 0 &&
            callist.find(x => x.category_id === item.category_id && x.start_time === item.start_time).bookok_count < item.count)
          ? "ご予約できない時間帯が選択されています。再選択してください" : null;
        booking_detail.push({
          ...item,
          book_date: item.book_date,
          total: CommonBooking.calcTotal(item.price, item.count),
          errcheck: errmsg,
        })
      }));
      booking = {
        ...booking_detail[0].t_booking,
        book_date: booking_detail[0].book_date,
        status: booking_detail[0].booking_status,
        shop_id: booking_detail[0].shop_id,
        talk_id: booking_detail[0].talk_id,
        talktext: booking_detail[0].talktext,
        category_id: booking_detail[0].category_id,
        connect_means: booking_detail[0].connect_means,
        customer_before_time: booking_detail[0].customer_before_time,
        customer_after_time: booking_detail[0].customer_after_time,
        staff_name: booking_detail[0].staff_name,
        booking_detail: booking_detail,
      };
      my_customer = {
        ...this.state.my_customer,
        customer_id: booking.detail_t_booking_customer.customer_id,
        customer_name: booking.detail_t_booking_customer.customer_name,
        customer_kana: booking.detail_t_booking_customer.customer_kana,
        customer_address: booking.detail_t_booking_customer.customer_address,
        customer_gender: booking.detail_t_booking_customer.customer_gender,
        customer_age_type: booking.detail_t_booking_customer.customer_age_type,
        card_id: booking.detail_t_booking_customer.card_id ? booking.detail_t_booking_customer.card_id : '',
        customer_address_number: booking.detail_t_booking_customer.customer_address_num,//郵便番号
        customer_address1: booking.detail_t_booking_customer.customer_address1,//県
        customer_address2: booking.detail_t_booking_customer.customer_address2,//市町村
        customer_address3: booking.detail_t_booking_customer.customer_address3,//番
        customer_phone: booking.detail_t_booking_customer.customer_phone,//電話番号
        customer_mobilephone: booking.detail_t_booking_customer.customer_mobilephone,//携帯電話番号
        birthdayy: booking.detail_t_booking_customer.birthdayy,
        birthdaym: booking.detail_t_booking_customer.birthdaym,
        birthdayd: booking.detail_t_booking_customer.birthdayd,
      }
      booking = {
        ...booking,
        customer_id: my_customer.customer_id,
        customer_name: my_customer.customer_name,
        customer_kana: my_customer.customer_kana,
        customer_address: my_customer.customer_address,
        customer_gender: my_customer.customer_gender,
        customer_age_type: my_customer.customer_age_type,
        card_id: my_customer.card_id ? my_customer.card_id : '',
        customer_address_number: my_customer.customer_address_number,//郵便番号
        customer_address1: my_customer.customer_address1,//県
        customer_address2: my_customer.customer_address2,//市町村
        customer_address3: my_customer.customer_address3,//番
        customer_phone: my_customer.customer_phone,//電話番号
        customer_mobilephone: my_customer.customer_mobilephone,//携帯電話番号
        birthdayy: my_customer.birthdayy,
        birthdaym: my_customer.birthdaym,
        birthdayd: my_customer.birthdayd,
      };
      await this.getCategoryList(booking.book_date);
      booked = { ...booking, booking_detail: booking_detail.concat() };
      selectarealist = this.state.shoplist && this.state.shoplist.find(shop => Number(shop.shop_id) === Number(booking.shop_id)) ? this.state.shoplist.find(shop => Number(shop.shop_id) === Number(booking.shop_id)).area_id : '';

    } else {
      booking = this.blankBooking();
      booking_detail = this.blankBookingDetail();
    }
    this.setState({
      book_id: book_id,
      book_set_id: book_set_id,
      set_booking: { ...booking },
      set_booking_detail: booking_detail.concat(),
      set_bookCalList: callist,
      my_customer,
      booking: booking,
      booking_detail: booking_detail,
      bookCalList: callist,
      recept: recept,
      bookingDetailList: bookingDetailList,
      booked,
      selectarealist: selectarealist,
      shopcahge: selectarealist === '' ? true : false,
      customer_after_select: booking.customer_after_time ? false : true,
      staff_name: booking.staff_name ? booking.staff_name : '',
      change: false,
    });
  }


  //エリア選択
  changeselectarea = (data) => {
    this.setState({ selectarealist: (data.target.value === '' ? '' : Number(data.target.value)) });
    var booking = {
      ...this.state.booking,
      shop_id: '',
    };
    //エリア変更に伴って選択している支所をリセットする
    this.setState({ booking, change: false });
    //選択の変更許可
    this.changeShop(data.target.value);
  }

  //支所選択
  changeSelectShop = async (data) => {
    var change = true;
    const selectedValue = data.target.value;
    var booking = {
      ...this.state.booking,
      shop_id: selectedValue,
    };
    //支所変更に伴って選択しているカレンダーをリセットする
    if (selectedValue === '' || this.state.booking.shop_id !== selectedValue) {
      await this.changeCategory(null, "")
      await this.getCategoryList(null);
      booking = {
        ...booking,
        category_id: null,
        book_date: null
      };
      change = false;
    }
    this.setState({
      booking,
      change: change
    });
  }

  //相談カテゴリー選択
  changeSelectTalk = (data) => {
    this.setState({ booking: { ...this.state.booking, talk_id: Number(data.target.value) } });
  }

  //支所選択許可
  changeShop = (select) => {
    var result = select === '' ? true : false
    this.setState({ shopcahge: result })
  }

  setPrefectures = () => {
    const prefectures = [
      { value: "", label: "- 都道府県 -" },
      { value: "北海道", label: "北海道" },
      { value: "青森県", label: "青森県" },
      { value: "岩手県", label: "岩手県" },
      { value: "宮城県", label: "宮城県" },
      { value: "秋田県", label: "秋田県" },
      { value: "山形県", label: "山形県" },
      { value: "福島県", label: "福島県" },
      { value: "茨城県", label: "茨城県" },
      { value: "栃木県", label: "栃木県" },
      { value: "群馬県", label: "群馬県" },
      { value: "埼玉県", label: "埼玉県" },
      { value: "千葉県", label: "千葉県" },
      { value: "東京都", label: "東京都" },
      { value: "神奈川県", label: "神奈川県" },
      { value: "新潟県", label: "新潟県" },
      { value: "富山県", label: "富山県" },
      { value: "石川県", label: "石川県" },
      { value: "福井県", label: "福井県" },
      { value: "山梨県", label: "山梨県" },
      { value: "長野県", label: "長野県" },
      { value: "岐阜県", label: "岐阜県" },
      { value: "静岡県", label: "静岡県" },
      { value: "愛知県", label: "愛知県" },
      { value: "三重県", label: "三重県" },
      { value: "滋賀県", label: "滋賀県" },
      { value: "京都府", label: "京都府" },
      { value: "大阪府", label: "大阪府" },
      { value: "兵庫県", label: "兵庫県" },
      { value: "奈良県", label: "奈良県" },
      { value: "和歌山県", label: "和歌山県" },
      { value: "鳥取県", label: "鳥取県" },
      { value: "島根県", label: "島根県" },
      { value: "岡山県", label: "岡山県" },
      { value: "広島県", label: "広島県" },
      { value: "山口県", label: "山口県" },
      { value: "徳島県", label: "徳島県" },
      { value: "香川県", label: "香川県" },
      { value: "愛媛県", label: "愛媛県" },
      { value: "高知県", label: "高知県" },
      { value: "福岡県", label: "福岡県" },
      { value: "佐賀県", label: "佐賀県" },
      { value: "長崎県", label: "長崎県" },
      { value: "熊本県", label: "熊本県" },
      { value: "大分県", label: "大分県" },
      { value: "宮崎県", label: "宮崎県" },
      { value: "鹿児島県", label: "鹿児島県" },
      { value: "沖縄県", label: "沖縄県" },
    ];

    const items = prefectures.map(pref => (
      <option value={pref.value} key={pref.value}>{pref.label}</option>
    ));

    return items;
  }

  //都道府県変更
  changeAddress1 = (data) => {
    const selectedValue = data.target.value;
    var booking = {
      ...this.state.booking,
      customer_address1: selectedValue,
    };
    this.setState({
      booking
    });
  }

  //市町村
  changeAddress2 = (data) => {
    const selectedValue = data.target.value;
    var booking = {
      ...this.state.booking,
      customer_address2: selectedValue,
    };
    this.setState({
      booking
    });
  }

  //丁目番地
  changeAddress3 = (data) => {
    const selectedValue = data.target.value;
    var booking = {
      ...this.state.booking,
      customer_address3: selectedValue,
    };
    this.setState({
      booking
    });
  }

  //電話番号
  changePhone = (data) => {
    var selectedValue = data.target.value;
    //「.」を消すための処理
    selectedValue = selectedValue.trim();
    selectedValue = selectedValue.replace(/\./g, '');
    if (!isNaN(selectedValue)) {
      var booking = {
        ...this.state.booking,
        customer_phone: selectedValue,
      };
      this.setState({
        booking
      });
    }
  }

  //携帯電話番号
  changeMobilephone = (data) => {
    var selectedValue = data.target.value;
    //「.」を消すための処理
    selectedValue = selectedValue.trim();
    selectedValue = selectedValue.replace(/\./g, '');
    if (!isNaN(selectedValue)) {
      var booking = {
        ...this.state.booking,
        customer_mobilephone: selectedValue,
      };
      this.setState({
        booking
      });
    }
  }

  blankBooking(my_customer = this.state.my_customer) {
    return {
      book_id: null,
      book_date: null,
      total: 0,
      card_id: my_customer.card_id ? my_customer.card_id : '',
      customer_id: my_customer.customer_id ? my_customer.customer_id : '',
      customer_name: my_customer.customer_name ? my_customer.customer_name : '',
      customer_kana: my_customer.customer_kana ? my_customer.customer_kana : '',
      customer_address_number: my_customer.customer_address_number ? my_customer.customer_address_number : '',
      customer_address1: my_customer.customer_address1 ? my_customer.customer_address1 : '',
      customer_address2: my_customer.customer_address2 ? my_customer.customer_address2 : '',
      customer_address3: my_customer.customer_address3 ? my_customer.customer_address3 : '',
      customer_phone: my_customer.customer_phone ? my_customer.customer_phone : '',
      customer_mobilephone: my_customer.customer_mobilephone ? my_customer.customer_mobilephone : '',
      customer_gender: my_customer.customer_gender,
      birthdayy: my_customer.birthdayy ? my_customer.birthdayy : '',
      birthdaym: my_customer.birthdaym ? my_customer.birthdaym : '',
      birthdayd: my_customer.birthdayd ? my_customer.birthdayd : '',
      privacy_policy: constClass.FLAG.OFF,
      payment_fin_flag: constClass.FLAG.OFF,
      shop_id: '',
      status: null,
    }
  }
  blankBookingDetail() {
    return [];
  }

  async getSelectArea() {
    const result = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/area/search`, { site_id: this.props.siteId, operator: "and", where: [{ site_id: this.props.siteId }] })).data;
    this.setState({ arealist: result });
  }
  async getSelectShop() {
    const result = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/shop/search/line`, { site_id: this.props.siteId, line_id: this.props.liff_access_token })).data;
    this.setState({ shoplist: result });
  }
  async getSelectTalk() {
    const result = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/talk_category/search`, { site_id: this.props.siteId, operator: "and", where: [{ site_id: this.props.siteId }] })).data;
    this.setState({ talklist: result });
  }
  async getCategoryList(book_date) {
    var params = {
      site_id: this.state.siteId,
      book_date: book_date ? book_date : null,
    }
    const categoryPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/category/list/`, params);
    const categoryMaster = (await categoryPromise).data;
    this.setState({ categoryMaster });
  }

  //予約対象のカレンダーリストを取得
  async getCalendarNew(book, book_detail, list = null) {
    if ((book.status && constClass.STATUS_CCL.includes(book.status))) return [];
    const params = {
      site_id: this.state.siteId,
      book_date: book.book_date,
      category_id: (book_detail && book_detail.category_id) ? book_detail.category_id : this.state.category_id,
      shop_id: this.state.booking.shop_id,
    }
    this.setState({ disabled: true });
    const dataPromise = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/calendar/search/`, params);
    this.setState({ disabled: false });

    return (dataPromise.data);

  }


  //予約対象のカレンダーリストを取得
  async getCalendarchang(book, book_detail, list = null) {
    if ((book.status && constClass.STATUS_CCL.includes(book.status))) return [];
    const params = {
      site_id: this.state.siteId,
      book_date: book.book_date,
      category_id: (book_detail && book_detail.category_id) ? book_detail.category_id : this.state.category_id,
      shop_id: book.shop_id,
    }
    this.setState({ disabled: true });
    const dataPromise = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/calendar/search/`, params);
    this.setState({ disabled: false });

    return (dataPromise.data);

  }

  //変更対象予約情報をセット
  async submitCurrentbooking(book_id, book_set_id, page) {
    await this.props.setCurrentBook(book_id);
    const url = `/${this.state.siteId}/?${page ? `page=${page}` : ""}${book_id ? `&id=${book_id}` : ""}${book_set_id ? `&no=${book_set_id}` : ""}`;
    this.props.history.push(url);
    await this.refreshBookData();
  }

  componentDidMount() {
    this.refreshData();
    this.disableBounceScroll();
  }

  disableBounceScroll() {
    let touchY = 0;

    document.body.addEventListener('touchstart', (e) => {
      touchY = e.touches[0].screenY;
    });

    document.body.addEventListener('touchmove', (e) => {
      let el = this.pageRef.current;// e.targetが機種によって変動するため、pageに固定
      const moveY = e.touches[0].screenY;
      let noScroll = true;

      while (el !== null) {
        if (el.offsetHeight < el.scrollHeight) {
          if (touchY < moveY && el.scrollTop === 0) {
            break;
          }
          if (touchY > moveY && el.scrollTop === el.scrollHeight - el.offsetHeight) {
            break;
          }
          noScroll = false;
          break;
        }
        el = el.parentElement;
      }
      if (noScroll) {
        if (e.cancelable) {
          e.preventDefault();
        }
      }

      touchY = moveY;
    }, { passive: false });
  }

  scrollPageTop() {
    setTimeout(() => {
      let el = this.pageRef.current;// e.targetが機種によって変動するため、pageに固定
      if (el) el.scrollTo(0, 0);
      else window.scrollTo(0, 0);
    }, 1);
  }

  scrollWindowTop() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  }

  changeCheck(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    var booking = { ...this.state.booking, [name]: value };
    this.setState({
      booking
    });
  }

  //郵便番号入力
  changeAddres_number = (event) => {
    var selectedValue = event.target.value;

    //「.」を消すための処理
    selectedValue = selectedValue.trim();
    selectedValue = selectedValue.replace(/\./g, '');
    if (!isNaN(selectedValue)) {
      var booking = {
        ...this.state.booking,
        customer_address_number: selectedValue,
      };
      this.setState({
        booking
      });
    }
  }

  //郵便番号からアドレスを取得 MemberNewInputから持ってきた
  searchAddress = async (postal_code2, target) => {
    if (!postal_code2 || postal_code2 === "") return;
    var postal_code = Common.zenkaku2hankaku(postal_code2);//半角に変換
    postal_code = postal_code.length === 7 ? `${postal_code.substring(0, 3)}-${postal_code.substring(3)}` : postal_code;//ハイフンなしの場合はつける
    // API実行
    var booking = null;
    try {
      const res = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/address/${postal_code}`)).data;
      if (res) {
        var address1 = '';
        var address2 = '';
        var address3 = '';
        if (res.PrefecturesName) {
          address1 += res.PrefecturesName;
        }
        if (res.CityName) {
          address2 += res.CityName;
        }
        if (res.TownName) {
          address3 += res.TownName;
        }
        // 都道府県リストを取得
        const prefectures = this.setPrefectures().map(pref => pref.props.children);
        const selectedPrefecture = prefectures.find(pref => pref === address1);
        booking = {
          ...this.state.booking,
          customer_address1: selectedPrefecture ? address1 : "",
          customer_address2: address2,
          customer_address3: address3,
        };
      } else if (!res && postal_code.length === 8) {
        booking = {
          ...this.state.booking,
          customer_address1: "",
          customer_address2: "",
          customer_address3: "",
        };
        alert('申し訳ありません。\n住所の取得ができませんでした。');
      } else {
        booking = {
          ...this.state.booking,
          customer_address1: "",
          customer_address2: "",
          customer_address3: "",
        };
      }
      this.setState({
        booking
      });
    } catch (err) {
      console.error("エラー：", err);
      alert('住所検索に失敗しました');
    }
  }

  changeDate_y = (event) => {
    var selectedValue = event.target.value;

    //「.」を消すための処理
    selectedValue = selectedValue.trim();
    selectedValue = selectedValue.replace(/\./g, '');

    if (!isNaN(selectedValue)) {
      var booking = {
        ...this.state.booking,
        birthdayy: selectedValue,
      };
      this.setState({
        booking
      });
    }
  }

  changeDate_m = (event) => {
    const selectedValue = event.target.value;
    var booking = {
      ...this.state.booking,
      birthdaym: selectedValue,
    };
    this.setState({
      booking
    });
  }

  changeDate_d = (event) => {
    const selectedValue = event.target.value;
    var booking = {
      ...this.state.booking,
      birthdayd: selectedValue,
    };
    this.setState({
      booking
    });
  }

  changeDate_before_Time = (event) => {
    const selectedValue = event.target.value;
    this.setState({ booking: { ...this.state.booking, customer_before_time: selectedValue } })
    if (selectedValue !== '') {
      this.setState({ customer_after_select: false })
    } else {
      this.setState({ booking: { ...this.state.booking, customer_before_time: '', customer_after_time: '' } })
      this.setState({ customer_after_select: true })
    }

    if (Number(selectedValue) >= Number(this.state.booking.customer_after_time)) {
      this.setState({ booking: { ...this.state.booking, customer_before_time: selectedValue, customer_after_time: '' } })
    }
  }
  changeDate_after_Time = (event) => {
    const selectedValue = event.target.value;
    this.setState({ booking: { ...this.state.booking, customer_after_time: selectedValue } })
  }

  setMonth = () => {
    const items = [];
    items.push(<option value="" key={"-"}>- 月 -</option>)
    for (let i = 1; i <= 12; i++) {
      items.push(<option value={("00" + i).slice(-2)} key={i}>{i}</option>)
    }
    return items;
  }
  setDay = (value) => {
    const items = [];
    const year = value.slice(0, 4);
    const month = value.slice(5, 7);
    items.push(<option value="" key={"-"}>- 日 -</option>)
    for (let i = 1; i <= 31; i++) {
      if (!year || !Number(month) || (new Date(year + '/' + month + '/' + ("00" + i).slice(-2)).getDate() === i)) {
        items.push(<option value={("00" + i).slice(-2)} key={i}>{i}</option>)
      }
    }
    return items;
  }

  setTimeBefore = () => {
    const start = Number(Common.getSettingValue(this.props.settings, "CUSTOMER_PHONE_TIME_START", 9));
    const end = Number(Common.getSettingValue(this.props.settings, "CUSTOMER_PHONE_TIME_END", 17)) - 1;
    const items = [];
    items.push(<option value="" key={"-"}>- 選択 -</option>)
    for (let i = start; i <= end; i++) {
      items.push(<option value={("00" + i).slice(-2)} key={i}>{i}</option>)
    }
    return items;
  }

  setTimeAfter = () => {
    const start = this.state.booking.customer_before_time ? (Number(this.state.booking.customer_before_time) + 1) : Number(Common.getSettingValue(this.props.settings, "CUSTOMER_PHONE_TIME_START", 9)) + 1;
    const end = Number(Common.getSettingValue(this.props.settings, "CUSTOMER_PHONE_TIME_END", 17));
    const items = [];
    items.push(<option value="" key={"-"}>- 選択 -</option>)
    for (let i = start; i <= end; i++) {
      items.push(<option value={("00" + i).slice(-2)} key={i}>{i}</option>)
    }
    return items;
  }

  //予約対象の取得と確認
  async setChangeBinDetail(book, book_detail) {
    var callist = this.state.bookCalList;
    var calmsg = this.state.bookCalListMessage;
    var total = 0;
    await Promise.all(book_detail.map(async (item, idx) => {
      if (this.state.category_id && book.book_date) {
        // 指定した日付・カテゴリのカレンダー(在庫数)を取得する
        var calendar = await this.getCalendarNew(book, book_detail[idx], book_detail);
        //予約可件数を計算
        calendar.forEach((item2, idx) => {
          var count = 0;
          if (this.state.booked && this.state.booked.booking_detail && this.state.booking.book_date === this.state.booked.book_date
            && this.state.booked.booking_detail.length >= 0) {
            const booked_detail = this.state.booked.booking_detail[0];
            //予約可件数に自身の予約済件数を加算
            count = (item2.start_time === booked_detail.start_time && item2.end_time === booked_detail.end_time) ? booked_detail.count : 0;
          }
          calendar[idx] = { ...item2, bookok_count: item2.bookok_count + count }
        });

        // 指定した開始時間～終了時間のカレンダー(在庫)が無い
        var errflag = false;
        if (book_detail[idx].start_time && book_detail[idx].end_time) {
          var cal_idx = calendar.findIndex(x => x.start_time === book_detail[idx].start_time && x.end_time === book_detail[idx].end_time);
          if (cal_idx >= 0 && calendar[cal_idx].bookok_count < book_detail[idx].count) {
            errflag = true;
          }
        }
        const errmsg = errflag ? "予約できない時間帯が選択されています。再選択してください。" : null;

        book_detail[idx] = {
          ...book_detail[idx],
          total: book_detail[idx].category_id ? CommonBooking.calcTotal(book_detail[idx].price, book_detail[idx].count) : 0,
          errcheck: errmsg,
        };
        total += book_detail[idx].total;
        callist = calendar;
        calmsg = calendar.length <= 0 ? "予約できる時間帯がありません" : null;
      }
    }));
    this.setState({
      booking: { ...book, total: total },
      booking_detail: book_detail,
      bookCalList: callist,
      bookCalListMessage: calmsg,
    });
  }

  /* 予約日変更 */
  async changeBookDate(val) {
    const book = { ...this.state.booking, book_date: val };
    await this.getCategoryList(val);
    await this.setChangeBinDetail(book, this.state.booking_detail);
  }
  // カテゴリ変更
  async changeCategory(val, text) {
    var booking_detail = this.state.booking_detail;
    const idx = 0;
    booking_detail[idx] = {
      ...booking_detail[idx],
      category_id: null,
      book_date: null,
      start_time: null,
      end_time: null,
      price_before_tax: null,
      price: null,
      tax_rate: null,
      count: 1,
      errcheck: null,
      total: 0,

      getoff_time: null,
      fare: null,
    };

    this.setState({
      category_id: Number(val),
      category_name: text,
      booking_detail: booking_detail,
      bookCalList: null,
      bookCalListMessage: null,
    });
  }

  async searchBin() {
    var booking_detail = this.state.booking_detail;
    const idx = 0;
    booking_detail[idx] = {
      ...booking_detail[idx],
      category_id: null,
      book_date: null,
      start_time: null,
      end_time: null,
      price_before_tax: null,
      price: null,
      tax_rate: null,
      count: 1,
      errcheck: null,
      total: 0,
    };
    if (this.state.category_id) {
      await this.setChangeBinDetail(this.state.booking, booking_detail);
    } else {
    }
  }

  // 時間帯変更
  changeBookSetId(val) {
    const value = val;
    var detail = this.state.booking_detail;
    const idx = 0;
    if (value) {
      if (value.bookok_count < detail[idx].count) {
        return
      }
    }
    // 予約時間可能時間内ではない場合は選択しない
    if (CommonBooking.checkChangeTime(this.state.booking.book_date, value.start_time, Common.getSettingValue(this.props.settings, "BOOKING_LIMIT", "0"), Common.getSettingValue(this.props.settings, "BOOKING_LIMIT_UNIT", "m")) === false) {
      return;
    }

    detail[idx] = {
      ...detail[idx],
      category_id: value && value.category_id ? value.category_id : null,
      category_name: this.state.category_name,
      book_date: value && value.book_date ? value.book_date : null,
      book_set_id: value && value.book_set_id ? value.book_set_id : null,
      start_time: value && value.start_time ? value.start_time : '',
      end_time: value && value.end_time ? value.end_time : null,
      price_before_tax: value && value.price_before_tax ? value.price_before_tax : null,
      price: value && value.price ? value.price : null,
      tax_rate: value && value.tax_rate ? value.tax_rate : null,
      count: value && value.count ? value.count : 1,
      remarks: value && value.remarks ? value.remarks : null,
      errcheck: null,
    };
    this.setChangeBinDetail(this.state.booking, detail);
  }

  changeClick = async (state, page) => {

    this.setState(state);
    this.props.history.push(`/${this.state.siteId}/?page=${page}`);
  }

  checkInvalid() {
    const c = this.state.booking;
    var inputCheck = false;
    const chk = this.state.booking_detail[0];
    switch (this.props.page) {
      //お客様情報の次への条件
      case constClass.USER:
        inputCheck = (!c.customer_name || !c.customer_kana || !c.customer_name.trim() || !c.customer_kana.trim() || !c.customer_address_number || !c.customer_address1 || !c.customer_address2 || !c.customer_address3 || !c.birthdayd || !c.birthdaym || !c.birthdayy || !this.state.booking.talk_id || !((this.state.booking.customer_before_time && this.state.booking.customer_after_time) || (!this.state.booking.customer_before_time && !this.state.booking.customer_after_time)) || !Common.dateValidation((c.birthdayy && c.birthdaym && c.birthdayd ? c.birthdayy + c.birthdaym + c.birthdayd : ''), true)) ? true : false;
        break;
      case constClass.INPUTALERT:
        inputCheck = (c.privacy_policy !== constClass.FLAG.ON)
        break;
      case constClass.INPUT:
        inputCheck = (!this.state.booking.book_date)
        break;
      case constClass.INPUTBIN1:
        inputCheck = !chk || !chk.category_id
        break;
      case constClass.AREASELECT:
        inputCheck = (this.state.booking.shop_id === null || this.state.booking.shop_id === '' || this.state.booking.shop_id === null || this.state.booking.shop_id === '');
        break
      default:
        break;
    }
    return inputCheck;
  }

  // 予約便の確認 true:有効
  checkBookingValid(booking, booking_detail, bookCalList, settings = null) {
    var errchk = [];
    booking_detail.forEach(detail => {
      if (detail.category_id && detail.start_time) {
        const bookcal = bookCalList.find(x => x.category_id === detail.category_id && x.start_time === detail.start_time);
        const count = bookcal ? bookcal.bookok_count : 0;
        if (detail.count > count) errchk.push(false);
      }
    });
    if (errchk.length > 0) return false;
    return true;
  }

  //時間帯が重なる予約件数制限
  checkBookingDateCount() {
    var res = 0;
    const book_date = this.state.booking.book_date;
    const list = this.state.bookingDetailList.filter(x => !(constClass.STATUS_CCL.includes(x.booking_status)) && (!this.state.booking.book_id || x.book_id !== this.state.booking.book_id) && x.book_date === book_date);
    this.state.booking_detail.forEach(detail => {
      if (list.filter(x => x.start_time < detail.end_time && x.end_time > detail.start_time).length >= parseInt(this.props.settings.MAX_SAME_TIME)) res = 1;
    });
    return res
  }
  // ご希望の連絡先の選択制限（電話番号が入力されていない場合は選択させない）
  checkDisabledCustomerMeans(phon) {
    if (phon === constClass.CUSTOMER_PHONE_TYPE.TEL) {
      if (!this.state.booking.customer_phone || String(this.state.booking.customer_phone).trim() === '') {
        return true;
      }
    } else {
      if (!this.state.booking.customer_mobilephone || String(this.state.booking.customer_mobilephone).trim() === '') {
        return true;
      }
    }
    return false;
  }
  //ご予約はこちらを押すとここが実行される
  resetBooking = async () => {
    var book;
    if (this.state.booking.card_id) {
      book = this.state.booking;
    } else {
      book = this.blankBooking();
    }
    const detail = this.blankBookingDetail();
    this.setState({
      booking: book,
      booking_detail: detail,
      bookCalList: null,
      bookCalListMessage: null,
      set_booking: { ...book },
      set_booking_detail: detail.concat(),
      set_bookCalList: null,
      booked: null,
      change: false,
    })
  }
  async submit() {
    // API実行
    if (!this.checkBookingValid(this.state.booking, this.state.booking_detail, this.state.bookCalList)) {
      alert('指定数の予約が取れません。時間帯または予約数の変更をお願いします。');
      return false;
    }
    const check_res = await this.checkBookingDateCount();
    if (check_res === 1) {
      alert(`時間帯が重なるご予約はできません。`);
      return false;
    }

    try {
      const detail = this.state.booking_detail.filter(x => (x.category_id)).map((item) => ({
        site_id: this.state.siteId,
        book_id: item.book_id ? item.book_id : null,
        book_set_id: item.book_set_id ? item.book_set_id : null,
        category_id: item.category_id,
        book_date: item.book_date,
        start_time: item.start_time,
        end_time: item.end_time,
        price_before_tax: item.price_before_tax,
        price: item.price,
        tax_rate: item.tax_rate,
        count: item.count,
        remarks: item.remarks,
        total: CommonBooking.calcTotal(item.price, item.count),
      })
      );
      var data = {
        card_id: this.state.booking.card_id ? this.state.booking.card_id : null,
        site_id: this.state.siteId,
        book_id: this.state.booking.book_id ? this.state.booking.book_id : null,
        book_date: new Date(this.state.booking.book_date),
        customer_id: this.state.booking.customer_id,
        receipt_num: (this.state.booking.book_id) ? this.state.booking.receipt_num : null,
        receipt_datetime: (this.state.booking.book_id) ? new Date(this.state.booking.receipt_datetime) : new Date(),
        customer_name: this.state.booking.customer_name,
        customer_kana: this.state.booking.customer_kana,
        customer_address: this.state.booking.customer_address,
        customer_address_number: this.state.booking.customer_address_number,
        customer_address1: this.state.booking.customer_address1,
        customer_address2: this.state.booking.customer_address2,
        customer_address3: this.state.booking.customer_address3,
        customer_phone: (this.state.booking.customer_phone) ? this.state.booking.customer_phone : null,
        customer_mobilephone: (this.state.booking.customer_mobilephone) ? this.state.booking.customer_mobilephone : null,
        birthdayY: this.state.booking.birthdayy,
        birthdayM: this.state.booking.birthdaym,
        birthdayD: this.state.booking.birthdayd,
        talk_id: this.state.booking.talk_id ? String(this.state.booking.talk_id) : null,
        talktext: this.state.booking.talktext,
        shop_id: String(this.state.booking.shop_id),
        connect_means: (this.state.booking.connect_means) ? this.state.booking.connect_means : null,
        customer_before_Time: (this.state.booking.customer_before_time) ? this.state.booking.customer_before_time : null,
        customer_after_Time: (this.state.booking.customer_after_time) ? this.state.booking.customer_after_time : null,
        customer_gender: this.state.booking.customer_gender ? this.state.booking.customer_gender : null,
        customer_age_type: this.state.booking.customer_age_type,
        privacy_policy: this.state.booking.privacy_policy,
        line_id: this.props.liff_access_token,
        subtotal: 0, discount: 0, tax: 0,
        total: CommonBooking.getTotal(detail),
        before_total: (this.state.booked && this.state.booked.total) ? this.state.booked.total : null,
        payment_fin_flag: (this.state.booking.book_id) ? this.state.booking.payment_fin_flag : constClass.FLAG.OFF,
        status: (this.state.booking.book_id) ? this.state.booking.status : (Number(CommonBooking.getTotal(detail)) === 0 ? constClass.STATUS.TREG : constClass.STATUS.UPAY), //初期ステータスは未決済、totalが0の時はTREG
        t_booking_detail: detail,
        before_booking_detail: (this.state.booking.book_id) ? this.state.booked.booking_detail : [],
        staff_name: this.state.booking.staff_name ? this.state.booking.staff_name : null,
      }

      this.setState({ disabled: true });

      var result = null;
      //送信するテキスト
      var sendtext = "";
      var book_farst = this.state.booking.book_id ? false : true;
      if (this.state.booking.book_id) {
        result = (await axios.put(`${process.env.REACT_APP_BACKEND_URL}/booking/${data.book_id}`, data));
        sendtext = "予約内容が変更されました"
      } else {
        result = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/`, data));
        sendtext = "仮予約が完了いたしました\n正式な予約までしばらくお待ちください"
      }
      this.setState({ disabled: false });

      if (result.data && result.data.result && !result.data.msg) {
        const book_id = result.data && result.data.result && result.data.book && result.data.book.book_id ? result.data.book.book_id : data.book_id;
        //console.log("result.data.book.status", result.data.book.status)
        if (book_id && result.data.book && result.data.book.status === constClass.STATUS.UPAY) {
          this.props.setCurrentBook(book_id);
          await this.refreshBookData();
          await this.submitPayment(book_id);
        } else {
          //送信してログを残す
          sendtext = "予約番号：" + book_id + "\n" + sendtext;
          var param = {
            site_id: this.props.siteId,
            user_id: null,
            line_id: this.props.liff_access_token,// liff_user_id
            text: sendtext,
            book_id: book_id,
            shop_id: this.state.booking.shop_id,
            card_id: this.state.booking.card_id,
            book_farst: book_farst,
          }
          await axios.post(`${process.env.REACT_APP_BACKEND_URL}/log/send/accsess`, param);
          this.submitCurrentbooking(null, null, constClass.FINISH);
        }
      } else {
        //err
        console.log(util.inspect(result))
        alert(`登録に失敗しました。${result.data.msg ? result.data.msg : ""}`);
      }
    } catch (e) {
      var errMsg = "";
      if (e.fileName && e.lineNumber) {
        // ファイル名と行番号が取得できたらメッセージとしてログに出力する
        errMsg = "ファイル名：" + e.fileName + "、 行番号：" + e.lineNumber;
      } else {
        errMsg = e.message;
      }
      //例外エラーがおきたら、コンソールにログを出力する
      console.error("エラー：", errMsg);
      alert('登録に失敗しました。2');
      this.setState({ disabled: false });
    }
    return false;
  }

  async submitPayment(book_id) {
    console.log("submitPayment");
    this.setState({ disabled: true });
    const params = {
      Overview: this.props.settings.TITLE_SHORT_NAME,
    };
    const payment_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/payment/${this.props.siteId}/${book_id}`, params)).data;
    //console.log("payment_data", payment_data)
    // urlがある⇒画面遷移
    if (payment_data.url) {
      const form = document.createElement('form');
      form.action = payment_data.url;
      form.method = payment_data.method;

      // body に追加
      document.body.append(form);
      for (const i in payment_data.data) {
        // obj.hasOwnProperty() はオブジェクトのプロトタイプチェーンからプロパティを絞り込むために使用しています
        if (payment_data.data.hasOwnProperty(i)) {
          const input = document.createElement('input');
          input.setAttribute('type', 'hidden');
          input.setAttribute('name', i);
          input.setAttribute('value', payment_data.data[i]);
          form.appendChild(input);
        }
      }

      // submit
      form.submit();
    } else {
      // urlが無い⇒paymentモジュール画面へ遷移
      this.setState({ payment_data: payment_data.data, disabled: false });
      this.props.history.push(`/${this.state.siteId}/?page=${constClass.PAYMENT}&id=${book_id}`);
    }
  }
  async backPayment() {
    console.log("backPayment")
    await this.refreshBookData();
  }
  async returnPayment() {
    console.log("returnPayment")
    await this.refreshBookData();
  }

  renderHeader() {
    const titlename = () => {
      switch (this.props.page) {
        case constClass.USER: return `お客様情報`;
        case constClass.INPUTALERT: return `注意事項`;
        case constClass.AREASELECT: return `支所選択`;
        case constClass.INPUT: return `予約登録`;
        case constClass.INPUTBIN1: return `予約登録`;
        case constClass.CONFIRM: return `予約登録`;
        case constClass.PAYMENT: return `決済`;
        case constClass.FINISH: return `予約完了`;
        case constClass.CHANGECONFIRM: return `予約内容確認`;
        case constClass.HISTORY: return `ご予約履歴・変更`;
        case constClass.CANCEL: return `キャンセル`;
        case constClass.RECEPT: return `受付`;
        case constClass.RECEPTQR: return `受付`;
        default: return `メニュー`;
      }
    }
    return (
      <header className="header">
        <div className="row mx-0">
          <div className={`col section text-center`}>
            {titlename(this)}
          </div>
        </div>
      </header>
    );
  }

  async getReceptdata(bookingDetailList, category_id = null) {
    const nowDate = moment().format('YYYYMMDD');
    const nowTime = moment().format('HHmmss');
    var recept = null;
    var list = [];
    await Promise.all(bookingDetailList.map(async item => {
      if (moment(item.book_date).format('YYYYMMDD') === nowDate && nowTime <= item.end_time && (!recept || recept.start_time > item.start_time) &&
        constClass.STATUS.FIN === item.booking_status) {
        recept = item;
      } else {
        if (constClass.STATUS_RECEPTOK.includes(item.booking_status) && moment(item.book_date).format('YYYYMMDD') === nowDate && nowTime <= item.end_time) {
          list.push(item);
        }
      }
    }));

    if (recept !== null) return recept;
    if (list.length > 0) {
      if (category_id && list.findIndex(x => x.category_id === category_id) >= 0) {
        return list.find(x => x.category_id === category_id);
      }
      return list[0];
    } else {
      return null;
    }
  }

  renderReceptButton() {
    return (
      <div className="row mx-0 mt-3 mb-3 text-center">
        <div className="col px-0">
          <button
            onClick={async (e) => this.submitCurrentbooking(this.state.recept ? this.state.recept.book_id : null, this.state.recept ? this.state.recept.book_set_id : null, constClass.RECEPTQR)}
            className={`btn btn-primary w-100 h-100 py-3 px-2`}>
            <div className='row m-0 p-0'>
              <div className='col-2 m-0 p-0 pl-2 text-left align-self-center'><img src={ReceptImg} style={{ width: "40px" }} alt={"受付"} /></div>
              <div className='col-8 m-0 p-0 text-center align-self-center'><span className="mb-0 h5 font-weight-bold">受付する</span></div>
            </div>
          </button>

        </div>
      </div>
    )
  }

  renderMenu() {
    return (
      <div className="row mx-0">
        <div className="col px-0">
          <div className="row mx-0">
            <div className="col py-4 text-center">
              <img className='w-75' src={`/${this.props.siteId}/ct__main.png`} alt="booking" onError={(e) => { e.target.onerror = null; e.target.style.display = 'none'; }} />
            </div>
          </div>
          {(("CONTRACT_PERIOD_STARTTIME" in this.props.settings) && parseInt(this.props.settings.CONTRACT_PERIOD_STARTTIME) > parseInt(moment().format('YYYYMMDDkkmm')))
            ?
            <div className="mx-3 px-3-env bg-green text-white h5 text-center">{this.props.settings.CONTRACT_PERIOD_BEFORE_MESSAGE}</div>
            :
            <div>
              <div className="row mx-0 px-3-env pt-2 pb-1">
                <div className="col py-1 px-1 align-self-center">
                  <div className="row mx-0 mt-3 mb-3 text-center">
                    <div className="col px-0">
                      <Link to={`/${this.state.siteId}/?page=${constClass.INPUTALERT}`}>
                        <button
                          onClick={e => this.resetBooking()}
                          className={`btn btn-primary btn-booking w-100 h-100 py-3 px-2`}>
                          <div className='row m-0 p-0'>
                            <div className='col-1 m-0 p-0 pl-2 align-self-center'><img src={`/${this.props.siteId}/icon_booking.png`} style={{ width: "2rem" }} alt="ご予約" /></div>
                            <div className='col-10 m-0 p-0 text-center align-self-center'><span className="mb-0 h5 font-weight-bold">ご予約はこちら</span></div>
                            <div className='col-1 m-0 align-self-center'></div>
                          </div>
                        </button>
                      </Link>
                    </div>
                  </div>
                  {
                    this.renderReceptButton()
                  }
                  <div className="row mx-0 my-3 text-center">
                    <div className="col-6 px-0 pr-1">
                      <Link to={`/${this.state.siteId}/?page=${constClass.HISTORY}`}>
                        <button
                          className={`btn btn-primary w-100 h-100 py-2 px-2`}>
                          <img src={`/${this.props.siteId}/icon_list.png`} style={{ width: "2rem" }} alt="list" /><br />
                          <span className="mb-0 h5 font-weight-bold">ご予約履歴<br />・変更</span>
                        </button>
                      </Link>
                    </div>
                    <div className="col-6 px-0 pl-1">
                      <a href={Common.getExternalUrl(this.props.settings.ATTENTION_URL)} target="_blank" rel="noreferrer">
                        <button
                          className={`btn btn-primary w-100 h-100 py-2 px-2`}>
                          <img src={`/${this.props.siteId}/icon_attention.png`} style={{ width: "2rem" }} alt="attention" /><br />
                          <span className="mb-0 h5 font-weight-bold">操作方法</span>
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
        </div>
      </div>
    );
  }

  renderUser() {
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col bg-white px-0 mb-3">
          <div id="user">
            <div className="row mx-0 px-3-env py-2 bg-green text-white">
              <div className='col font-weight-bold text-center'>お客様情報をご入力ください</div>
            </div>
            <div className="px-3-env py-2">{/*※複数人でご利用される場合は、代表者の情報をご入力ください。*/}</div>
            <div>
              <div className="row mx-0 px-3-env pt-2">
                <div className="col px-0 text-green font-weight-bold">
                  会員番号
                </div>
              </div>
              <div className="row mx-0 px-3-env text-left form-group">
                <div className="col px-0">
                  {(this.state.booking && this.state.booking.card_id) ? this.state.booking.card_id : "JA山口会員ポイントアプリ未登録です"}
                </div>
              </div>
            </div>

            <div className="row mx-0 px-3-env pt-2">
              <div className="col px-0 text-green font-weight-bold">
                お名前(必須)
              </div>
            </div>
            <div className="row mx-0 px-3-env text-left form-group">
              <div className="col px-0">
                <input type="text" className="form-control" id="customer_name" name="customer_name" onChange={e => this.changeCheck(e)} onBlur={this.scrollWindowTop} value={this.state.booking.customer_name} placeholder="例）予約 太郎" />
                <span className='small'>※氏名をご入力ください。</span>
              </div>
            </div>
            <div className="row mx-0 px-3-env pt-2">
              <div className="col px-0 text-green font-weight-bold">
                カナ氏名(必須)
              </div>
            </div>
            <div className="row mx-0 px-3-env text-left form-group">
              <div className="col px-0">
                <input type="text" className="form-control" id="customer_kana" name="customer_kana" onChange={e => this.changeCheck(e)} onBlur={this.scrollWindowTop} value={this.state.booking.customer_kana} placeholder="例）ニシテツ タロウ" />
                <span className='small'>※カタカナで氏名をご入力ください。</span>
              </div>
            </div>
            <div className="row mx-0 px-3-env text-left form-group">
              <div className="col-12 px-0"><label className="col px-0 text-green font-weight-bold">郵便番号(必須)</label></div>
              <div className="col-6 px-0"><input type="text" className="form-control" id="customer_address_number" name="customer_address_number" value={this.state.booking.customer_address_number || ""} onChange={this.changeAddres_number} onBlur={this.scrollWindowTop()} placeholder='例)7540002' inputMode={"numeric"} maxLength={7}></input></div>
              <div className="col-auto px-2"><button className='btn btn-main-active w-100 border' onClick={() => this.searchAddress(this.state.booking.customer_address_number, 'customer_address')}>住所検索</button></div>
            </div>
            {/* 都道府県 */}
            <div className="row mx-0 px-3-env pt-2">
              <div className="col px-0 text-green font-weight-bold">住所(必須)</div>
              <div className='col-12 mx-0 px-0'>
                <select className={`form-control text-left`} id='customer_address1' name="customer_address1" onChange={this.changeAddress1} value={this.state.booking.customer_address1 || ""}>
                  {this.setPrefectures()}
                </select>
              </div>
              {/* 市町村 */}
              <div className="col-12 px-0 py-1">
                <input type="text" className="form-control" id="customer_address2" name="customer_address2" onChange={this.changeAddress2} onBlur={this.scrollWindowTop} value={this.state.booking.customer_address2} placeholder="例）山口市" />
              </div>

              {/* 丁目番地 */}
              <div className="col-12 px-0">
                <input type="text" className="form-control" id="customer_address3" name="customer_address3" onChange={this.changeAddress3} onBlur={this.scrollWindowTop} value={this.state.booking.customer_address3} />
              </div>
            </div>

            <div className="row mx-0 px-3-env pt-2">
              <div className="col px-0 text-green font-weight-bold">
                電話番号
              </div>
            </div>
            <div className="row mx-0 px-3-env text-left form-group">
              <div className="col px-0">
                <input type="text" className="form-control" id="customer_phone" name="customer_phone" onChange={this.changePhone} onBlur={this.scrollWindowTop} value={this.state.booking.customer_phone || ""} placeholder='例)0839733500' inputMode={"numeric"} />
              </div>
            </div>
            <div className="row mx-0 px-3-env pt-2">
              <div className="col px-0 text-green font-weight-bold">
                携帯電話番号
              </div>
            </div>
            <div className="row mx-0 px-3-env text-left form-group">
              <div className="col px-0">
                <input type="text" className="form-control" id="customer_mobilephone" name="customer_mobilephone" onChange={this.changeMobilephone} onBlur={this.scrollWindowTop} value={this.state.booking.customer_mobilephone || ""} placeholder='例)09012345678' inputMode={"numeric"} />
              </div>
            </div>

            {/* 生年月日を入力 */}
            <div className="row mt-2 mx-0 px-3-env text-left">
              <div className="col-12 px-0"><label className=" text-green font-weight-bold" htmlFor="birthdayy">生年月日(必須)</label></div>
              <div className='col-auto mx-0 px-1 py-2'>西暦</div>
              <div className='col mx-0 px-0' style={{ maxWidth: "5rem" }}>
                <input type="text" className={`form-control`} id="birthdayy" name="birthdayy" onChange={this.changeDate_y} value={this.state.booking.birthdayy || ""} inputMode={"numeric"} maxLength={4} />
              </div><div className='col-auto mx-0 px-1 py-2'>年</div>

              <div className='col-auto mx-0 px-0' style={{ maxWidth: "4rem" }}>
                <select className={`form-control text-center`} id="birthdaym" name="birthdaym" onChange={this.changeDate_m} value={this.state.booking.birthdaym || ""} >
                  {this.setMonth()}
                </select>
              </div><div className='col-auto mx-0 px-1 py-2'>月</div>

              <div className='col-auto mx-0 px-0' style={{ maxWidth: "4rem" }}>
                <select className={`form-control text-center`} id="birthdayd" name="birthdayd" onChange={this.changeDate_d} value={this.state.booking.birthdayd || ""}>
                  {this.setDay(this.state.customer_birthday || "")}
                </select>
              </div><div className='col-auto mx-0 px-1 py-2'>日</div>
            </div>


            <div className="row mx-0 px-3-env pt-2">
              <div className="col px-0 text-green font-weight-bold">
                性別
              </div>
            </div>
            <div className="row mx-0 px-3-env text-left form-group">
              {constClass.CUSTOMER_GENDER.map((customer_gender, idx) => (
                <div key={idx} className={`col mx-1 px-3-env align-self-center form-control custom-radio ${String(customer_gender) === String(this.state.booking.customer_gender) ? "border-green bg-lightyellow" : "border-gray"}`}>
                  <input type="radio" className="custom-control-input" id={`customer_gender_${customer_gender}`} name="customer_gender" onChange={e => this.changeCheck(e)} value={customer_gender} onBlur={this.scrollWindowTop} checked={String(this.state.booking.customer_gender) === String(customer_gender)} />
                  <label className="custom-control-label text-nowrap" htmlFor={`customer_gender_${customer_gender}`}>{constClass.CUSTOMER_GENDER_NAME[customer_gender]}</label>
                </div>
              ))}
            </div>
          </div>
          <div className="row mx-0 px-3-env pt-2">
            <div className="col-12 px-0 text-green font-weight-bold">
              予約の目的(必須)
            </div>
            <div className="col-12 px-0">
              {/* 相談内容プルダウン */}
              <select className="form-control" id="talk_id" name="talk_id" aria-label="相談カテゴリー"
                value={this.state.booking.talk_id ? this.state.booking.talk_id : ""}
                onChange={this.changeSelectTalk}>
                <option value="" >- 選択 -</option>
                {this.state.talklist.map((item, idx) =>
                  <option key={idx} value={item.talk_id}>{item.talk}</option>
                )}
              </select>
            </div>
          </div>
          <div className="row mx-0 px-3-env pt-2">
            <div className="col-12 px-0 small">
              {Common.getBrString(Common.getSettingValue(this.props.settings, "TALK_TEXT", ""))}
            </div>
            {/* 相談内容 */}
            <div className="col-12 px-0 ">
              <textarea className="form-control" id="talktext" name="talktext" onChange={e => this.changeCheck(e)} onBlur={this.scrollWindowTop} value={this.state.booking.talktext ? this.state.booking.talktext : ''} />
            </div>
            <div className="col-12 px-0 small">
              {Common.getBrString(Common.getSettingValue(this.props.settings, "TALK_TEXT2", ""))}
            </div>
            <div className="col-12 px-0 text-green font-weight-bold">
              ご希望の連絡先
            </div>
            <div className="row mx-0 text-left form-group">
              {constClass.CUSTOMER_PHONE.map((customer_phon, idx) => (
                <div key={idx} className={`col mx-1 px-3-env align-self-center form-control custom-radio ${String(customer_phon) === String(this.state.booking.connect_means) ? "border-green bg-lightyellow" : "border-gray"}`}>
                  <input disabled={this.checkDisabledCustomerMeans(customer_phon)} type="radio" className="custom-control-input" id={`connect_means${customer_phon}`} name="connect_means" onChange={e => this.changeCheck(e)} value={customer_phon} onBlur={this.scrollWindowTop} checked={String(this.state.booking.connect_means) === String(customer_phon)} />
                  <label className="custom-control-label text-nowrap" htmlFor={`connect_means${customer_phon}`}>{constClass.CUSTOMER_PHONE_NAME[customer_phon]}</label>
                </div>
              ))}
            </div>

            <div className="row px-3-env">
              <div className="col-12 px-0 text-green font-weight-bold">
                平日連絡可能時間
              </div>
              <div className='col-auto mx-0 px-0' style={{ maxWidth: "6rem" }}>
                <select className={`form-control text-center`} onChange={this.changeDate_before_Time} value={this.state.booking.customer_before_time || ""} >
                  {this.setTimeBefore()}
                </select>
              </div>
              <div className='col-auto mx-0 px-1 py-2'>時～</div>
              {/* this.state.customer_before_timeで操作可能かがわかる */}

              <div className='col-auto mx-0 px-0' style={{ maxWidth: "6rem" }}>
                <select className={`form-control text-center`} onChange={this.changeDate_after_Time} value={this.state.booking.customer_after_time || ""} disabled={this.state.customer_after_select} >
                  {this.setTimeAfter()}
                </select>
              </div>
              <div className='col-auto mx-0 px-1 py-2'>時</div>
              <div className="col-12 px-0 small">
                {Common.getBrString(Common.getSettingValue(this.props.settings, "CONTACT_MESSAGE", ""))}
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }

  renderInputAlert() {
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col px-0 pb-3">
          <div className="row m-0 px-0-env">
            <div className="col bg-white px-0 mb-3">
              <div id="inputalert">
                <div className="row mx-0 px-3-env">
                  <div className="col ml-0 pl-0">
                    {/* 規約の文章 */}
                    {Common.getBrString(Common.getSettingValue(this.props.settings, "CUSTOMER_RULE", ""))}

                    {/* リンク */}
                    {Common.getSettingValue(this.props.settings, 'SPECIFIED_COMMERCIAL_TRANSACTIONS_URL', '') && Common.getSettingValue(this.props.settings, 'SPECIFIED_COMMERCIAL_TRANSACTIONS_TEXT', '') &&
                      <a href={Common.getSettingValue(this.props.settings, 'SPECIFIED_COMMERCIAL_TRANSACTIONS_URL', '')}><u>{Common.getSettingValue(this.props.settings, "SPECIFIED_COMMERCIAL_TRANSACTIONS_TEXT", "")}</u></a>
                    }{Common.getSettingValue(this.props.settings, 'SPECIFIED_COMMERCIAL_TRANSACTIONS_URL', '') && Common.getSettingValue(this.props.settings, 'SPECIFIED_COMMERCIAL_TRANSACTIONS_TEXT', '') && <br />}
                    {Common.getSettingValue(this.props.settings, 'TERMS_OF_SERVICE_URL', '') && Common.getSettingValue(this.props.settings, 'TERMS_OF_SERVICE_TEXT', '') &&
                      <a href={Common.getSettingValue(this.props.settings, 'TERMS_OF_SERVICE_URL', '')}><u>{Common.getSettingValue(this.props.settings, "TERMS_OF_SERVICE_TEXT", "")}</u></a>
                    }{Common.getSettingValue(this.props.settings, 'TERMS_OF_SERVICE_URL', '') && Common.getSettingValue(this.props.settings, 'TERMS_OF_SERVICE_TEXT', '') && <br />}
                    {Common.getSettingValue(this.props.settings, 'PRIVACYPOLICY_URL', '') && Common.getSettingValue(this.props.settings, 'PRIVACYPOLICY_TEXT', '') &&
                      <a href={Common.getSettingValue(this.props.settings, 'PRIVACYPOLICY_URL', '')}><u>{Common.getSettingValue(this.props.settings, "PRIVACYPOLICY_TEXT", "")}</u></a>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mx-0 px-3-env pt-2 pb-1">
            <div className='col'>
              <div className="row mx-0 px-3-env pt-2 pb-1">
                <div className='col-12 text-center bg-white py-2'>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" className="custom-control-input" id="privacy_policy" name="privacy_policy" value="true" checked={this.state.booking.privacy_policy === constClass.FLAG.ON} onChange={e => this.changeCheck(e)} />
                    <label className="custom-control-label m-1" htmlFor="privacy_policy">同意する</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderInputCount() {
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col bg-white px-0 mb-3">
          <div id="book">
            <div className="row mx-0 px-3-env py-2 bg-green text-white">
              <div className='col font-weight-bold text-center'>ご予約日を選択してください</div>
            </div>
            <div className="row mx-0 px-3-env pt-2 pb-1">
              <div className="col-auto text-green font-weight-bold p-1">
                ご予約日
              </div>
              <div className="col">
                <select className="custom-select w-100 text-center" aria-label="予約日"
                  value={this.state.booking.book_date || ''}
                  onChange={(e) => this.changeBookDate(e.target.value)}
                  onBlur={this.scrollWindowTop}>
                  <option value="" >- 選択 -</option>
                  {this.state.bookDateList.map((item, idx) =>
                    <option key={idx} value={item.book_date}>{moment(item.book_date).format('YYYY/MM/DD')}({moment(item.book_date).format('dd')})</option>
                  )}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }


  renderArea() {
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col bg-white px-0 mb-3">
          <div id="book">
            <div className="row mx-0 px-3-env py-2 bg-green text-white">
              <div className='col font-weight-bold text-center'>支所を選択してください。</div>
            </div>
            <div className="row mx-0 px-3-env pt-2 pb-1">
              <div className="col-3 mx-0 p-0 align-self-center text-green font-weight-bold">
                エリア
              </div>
              <div className="col">
                <div className="row mx-0 px-3-env py-2 text-white">
                  {/* 下の支所を参考にしながらエリアのセレクトも作成する */}
                  <select className="custom-select w-100 text-center" aria-label="エリア"
                    value={this.state.selectarealist}
                    onChange={this.changeselectarea}
                  >
                    <option value="" >- 選択 -</option>
                    {/* ここの1を後でエリア指定に変える */}
                    {this.state.arealist.map((item, idx) =>
                      <option key={idx} value={item.area_id}>{item.area_name}</option>
                    )}
                  </select>
                </div>
              </div>
            </div>
            <div className="row mx-0 px-3-env pt-2 pb-1">
              <div className="col-3 mx-0 p-0 align-self-center text-green font-weight-bold">
                支所
              </div>
              <div className="col">
                <div className="row mx-0 px-3-env py-2 text-white">
                  <select className="custom-select w-100 text-center" aria-label="支所"
                    value={this.state.booking.shop_id}
                    onChange={this.changeSelectShop}
                    disabled={this.state.shopcahge}//エリアセレクトが行われてない状態では選択不可
                  >
                    <option value="" >- 選択 -</option>
                    {this.state.shoplist.filter(d => d.area_id === this.state.selectarealist).map((item, idx) =>
                      <option key={idx} value={item.shop_id}>{item.shop_name}</option>
                    )}
                  </select>
                </div>
              </div>
            </div>
            <div className="row mx-0 px-3-env py-2">
              {Common.getSettingValue(this.props.settings, 'SHOP_LIST_URL', '') && Common.getSettingValue(this.props.settings, 'SHOP_LIST_TEXT', '') &&
                <a href={Common.getExternalUrl(this.props.settings[`SHOP_LIST_URL`])}><u>※{this.props.settings.SHOP_LIST_TEXT}</u></a>
              }
            </div>
          </div>
        </div>
      </div >
    );
  }

  renderInputBin() {
    const checkBooking = (item) => {
      if (item.bookok_count < this.state.booking_detail[0].count) {
        return false;
      }
      if (CommonBooking.checkChangeTime(item.book_date, item.start_time, this.props.settings.BOOKING_LIMIT || 0, this.props.settings.BOOKING_LIMIT_UNIT || 'm') === false) {
        return false;
      }
      return true;
    }
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col bg-white px-0 mb-3">
          <div id="book">
            <div className="row mx-0 px-3-env py-2 bg-green text-white">
              <div className='col font-weight-bold text-center'>カテゴリを選択してください。</div>
            </div>
            <div className="row mx-0 px-3-env pt-2 pb-1">
              <div className="col-3 mx-0 p-0 align-self-center text-green font-weight-bold">
                カテゴリ
              </div>
              <div className="col">
                <select className={`custom-select w-100 text-center ${(this.state.booking_detail.length > 0 && this.state.booking_detail[0].category_id === this.state.category_id) ? "bg-lightyellow" : ""}`} aria-label="カテゴリ"
                  value={this.state.category_id}
                  onChange={(e) => this.changeCategory(e.target.value, e.target[e.target.selectedIndex].text)} onBlur={this.scrollWindowTop}>
                  <option value="" >- 選択 -</option>
                  {this.state.categoryMaster.map((item) =>
                    <option key={item.category_id} value={item.category_id}>{item.category_name}</option>
                  )}
                </select>
              </div>
            </div>
            <div className="row mx-0 px-3-env">
              <div className="col text-green font-weight-bold text-center">
                <button className='btn btn-active m-2 px-5'
                  onClick={e => this.searchBin()}>検索</button>
              </div>
            </div>
            {(this.state.bookCalList) &&
              <React.Fragment>
                <ul className='list-group'>
                  {this.state.bookCalListMessage && <li className={`px-2 list-group-item align-items-center`}>{this.state.bookCalListMessage}</li>}
                  {/* 日付が今日ではない、もしくは現時刻より後という条件で絞り込み */}
                  {!this.state.bookCalListMessage && this.state.bookCalList.filter((item) => (moment().format('YYYY/MM/DD') !== moment(item.book_date).format('YYYY/MM/DD') || Number(new Date().toTimeString().slice(0, 8).replace(/:/g, '')) < Number(item.start_time.replace(":", "")))).map((item, idx) => (
                    <li key={idx}
                      className={`px-2 list-group-item list-group-item-link d-flex justify-content-between align-items-center ${(this.state.booking_detail[0].category_id === item.category_id && this.state.booking_detail[0].start_time === item.start_time) ? 'bg-lightyellow' : checkBooking(item) ? 'bg-white' : 'bg-secondary text-white'}`}
                      onClick={e => this.changeBookSetId(item)}
                    >
                      <div className='row w-100'>
                        <div className='col'>
                          <div className='row'>
                            {(item.start_time || item.end_time) &&
                              <div className='col'>
                                <span className={`${(this.state.booking_detail[0].category_id === item.category_id && this.state.booking_detail[0].start_time === item.start_time) ? 'text-green' : ""}`}>
                                  {CommonBooking.strTotime(item.start_time)} ～ {CommonBooking.strTotime(item.end_time)}</span><br />
                                <div className="col-auto  font-weight p-1">
                                  {item.remarks}
                                </div>
                              </div>}
                            <div className='col-auto px-2'>
                              {(CommonBooking.checkChangeTime(item.book_date, item.start_time, this.props.settings.BOOKING_LIMIT || 0, this.props.settings.BOOKING_LIMIT_UNIT || 'm')) ? `残数：${(item.bookok_count < this.state.booking_detail[0].count) ? "×" : item.bookok_count}` : "受付終了"}
                            </div>
                          </div>
                          {(item.book_stop_message) && <div className='row'><div className='col text-red small'>予約停止：{item.book_stop_message}</div></div>}
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </React.Fragment>
            }
          </div>
        </div>
        {(this.props.settings && "BOOKING_CATEGORY_SELECT_COMMENT" in this.props.settings) && <div className='row mx-0 px-3-env pt-2 pb-1'>
          {this.props.settings["BOOKING_CATEGORY_SELECT_COMMENT"]}
        </div>}
        {(this.props.settings.BOOKING_LIMIT && !Number.isNaN(this.props.settings.BOOKING_LIMIT) && Number(this.props.settings.BOOKING_LIMIT) > 0) &&
          <div className='row mx-0 px-3-env pt-2 pb-1'>
            予約の{this.state.book_id ? "変更" : "登録"}は、{this.props.settings.BOOKING_LIMIT}{constClass.TIME_UNIT[this.props.settings.BOOKING_LIMIT_UNIT || "m"]}前まで可能です
          </div>
        }
      </div >
    );

  }

  renderConfirm() {
    var total = null;
    total = CommonBooking.getTotal(this.state.booking_detail, (this.state.booking.refund_total ? this.state.booking.refund_total : 0));
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col px-0 pb-2">
          <div id="bookinputcheck">
            {!this.state.change && <React.Fragment>
              {this.state.booking.status === constClass.STATUS.TREG &&
              <div>
                受付番号: {this.state.booking.receipt_num}
                <h4 className='text-center px-3-env py-2'>
                  仮予約
                </h4>
              </div>
              }{[constClass.STATUS.REG, constClass.STATUS.PRE].includes(this.state.booking.status) &&
                <div>
                受付番号: {this.state.booking.receipt_num}
                  <h4 className='text-center px-3-env py-2'>
                    予約承認済
                  </h4>
                </div>
              }
              {this.state.booking.status === constClass.STATUS.FIN &&
              <div>
                受付番号: {this.state.booking.receipt_num}
                <h4 className='text-center px-3-env py-2'>
                  来店済
                </h4>
              </div>
              }
              {this.state.booking.status === constClass.STATUS.CCL &&
              <div>
                受付番号: {this.state.booking.receipt_num}
                <h4 className='text-center px-3-env py-2'>
                  キャンセル済
                </h4>
              </div>
              }
              {this.state.booking.status === constClass.STATUS.CUPAY &&
                <h5 className='text-center px-3-env py-2 bg-white'>
                  決済期限切れです。<br />
                  お手数ですが、再度やり直してください。
                </h5>
              }
            </React.Fragment>}
            {(!this.state.change && this.state.booking.status === constClass.STATUS.UPAY
              && this.state.booking_detail.findIndex(x => (CommonBooking.checkChangeTime(x.book_date, x.start_time, this.props.settings.CANCEL_LIMIT, this.props.settings.CANCEL_LIMIT_TYPE || "m"))) >= 0) &&
              <h4 className='text-center px-3-env py-2 bg-white'>
                決済が完了していません。
                <button className="btn btn-danger" onClick={e => this.submitPayment(this.state.booking.book_id)}>決済へ進む</button>
              </h4>
            }
            <BookingDetailView
              state={this.state}
              cancel_view={false}
              settings={this.props.settings}
              onChangeClick={(state, page) => { this.changeClick(state, page); }}
              checkBookingValid={this.checkBookingValid}
              customer={this.state.booking.detail_t_booking_customer}
            />
            {
              this.state.booking.refund_total > 0 &&
              <div className="row mx-0 mt-3 py-2 pb-0 bg-white">
                <div className="col py-2 font-weight-bold text-green text-right">
                  払い戻し額
                </div>
                <div className="col-auto py-2 font-weight-bold text-green text-right">
                  {parseInt(this.state.booking.refund_total).toLocaleString()}円<br />
                </div>
              </div>
            }
            {total.toLocaleString() !== '0' &&
              <div className="row mx-0 mt-3 py-2 pb-0 bg-white">
                <div className="col py-2 font-weight-bold text-green text-right">
                  合計
                  {(this.state.booking.book_id && this.state.booking.status === constClass.STATUS.UPAY) && "※未決済"}
                </div>
                <div className="col-auto py-2 font-weight-bold text-green text-right">
                  {total.toLocaleString()}円<br />
                </div>
              </div>
            }
          </div>
          {(!this.state.change && constClass.STATUS_PRE.includes(this.state.booking.status) && this.state.booking.book_id && this.state.booking.book_date && moment(this.state.booking.book_date).isSameOrAfter(moment(), 'day')) &&
            <React.Fragment>
              <div className="row mx-0 pt-2 pb-0">
                {this.props.settings.CANCEL_LIMIT &&
                  <div className="col">
                    {CommonBooking.checkChangeTime(this.state.booking.book_date, this.state.booking_detail[0].start_time, this.props.settings.CANCEL_LIMIT, this.props.settings.CANCEL_LIMIT_UNIT || "m") ?
                      `予約時間${this.props.settings.CANCEL_LIMIT>0 ? `の${this.props.settings.CANCEL_LIMIT}${constClass.TIME_UNIT[this.props.settings.CANCEL_LIMIT_UNIT || "m"]}前` : ''}を過ぎると予約取り消しができなくなります`
                      :
                      `予約時間${this.props.settings.CANCEL_LIMIT>0 ? `の${this.props.settings.CANCEL_LIMIT}${constClass.TIME_UNIT[this.props.settings.CANCEL_LIMIT_UNIT || "m"]}前` : ''}を過ぎているため、予約取り消しはできません`}
                  </div>
                }
              </div>
              {CommonBooking.checkChangeTime(this.state.booking.book_date, this.state.booking_detail[0].start_time, this.props.settings.CANCEL_LIMIT, this.props.settings.CANCEL_LIMIT_UNIT || "m") &&
                <div className="row mx-0 pt-2 pb-3">
                  <div className="col font-weight-bold text-center">
                    <button
                      className={`btn btn-primary py-2 px-1 w-75`}
                      onClick={() => this.submitCurrentbooking(this.state.booking.book_id, null, constClass.CANCEL)}>
                      予約取り消し
                    </button>
                  </div>
                </div>}
            </React.Fragment>}
          {(Common.getSettingValue("PAY_CANCEL_DETAIL_MESSAGE", this.props.settings, null) !== null && Common.getSettingValue("PAY_CANCEL_DETAIL_URL", this.props.settings, null) !== null) &&
            <div className='row mx-0 pt-2 pb-0'>
              <div className='col mx-2 text-red'><a href={Common.getExternalUrl(this.props.settings[`PAY_CANCEL_DETAIL_URL`])} target="_blank" rel="noreferrer"><u>※{this.props.settings.PAY_CANCEL_DETAIL_MESSAGE}</u></a></div>
            </div>
          }
        </div>
      </div>
    )
  }

  renderPayment() {
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col p-1">
          <Payment
            siteId={this.props.siteId}
            lineId={this.props.liff_access_token}
            id={this.state.payment_data.id}
            amount={this.state.payment_data.amount}
            fee={this.state.payment_data.fee}
            backUrl={this.state.payment_data.backUrl}
            returnUrl={this.state.payment_data.returnUrl}
            checkUrl={this.state.payment_data.checkUrl}
            redirectReturnUrl={this.state.payment_data.redirectReturnUrl}
            abortUrl={`/${this.state.siteId}/`}
            backFunc={this.backPayment}
            returnFunc={this.returnPayment} />
        </div>
      </div>
    );
  }

  renderBookSelect() {

    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col px-0">
          <div id="booklist">
            {this.state.bookingDetailList.filter(b => (
              moment(b.book_date).isAfter(moment().subtract(1, "month").format('YYYY-MM-DD'))//1ヶ月前まで表示
              /*&& b.booking_status !== constClass.STATUS.UPAY && b.booking_status !== constClass.STATUS.CUPAY // 未決済は一覧に表示しない*/
            )).length === 0 &&
              <div>
                <div className="row mx-0 px-3-env pt-2 pb-1 bg-green text-white">
                  <div className='col-12 py-3 h5 text-center'>ご予約はありません。</div>
                </div>
              </div>
            }
            {this.state.bookingDetailList.filter(b => moment(b.book_date).isSameOrAfter(moment().format('YYYY-MM-DD')) && constClass.STATUS_NFIN.includes(b.booking_status) /*&& b.booking_status !== constClass.STATUS.UPAY*/) // 未決済は表示しない
              .sort((a, b) => (moment(`${a.book_date} ${CommonBooking.strTotime(a.start_time)}`, 'YYYY-MM-DD k:mm').format('YYYYMMDDkkmm') - moment(`${b.book_date} ${CommonBooking.strTotime(b.start_time)}`, 'YYYY-MM-DD k:mm').format('YYYYMMDDkkmm'))) //予約済み・事前通知済みのみ 
              .map((item, idx) => (
                <div className="row mx-0 my-3 text-center" key={`${idx}`}>
                  <div className="col px-0">
                    <button
                      onClick={async (e) => { this.submitCurrentbooking(item.book_id, item.book_set_id, (item.booking_status === constClass.STATUS.FIN) ? constClass.RECEPT : constClass.CHANGECONFIRM); }}
                      className={`btn btn-${(item.booking_status !== constClass.STATUS.FIN && !CommonBooking.checkChangeTime(item.book_date, item.start_time, 0)) ? "secondary" : item.booking_status === constClass.STATUS.UPAY ? "danger" : "primary"} w-100 h-100 py-2 px-2`}>
                      <div className='row'>
                        <div className='col'>受付番号：{item.t_booking.receipt_num}</div>
                      </div>
                      <div className='row'>
                        {(item.start_time || item.end_time) ?
                          <div className='col'>{moment(item.book_date).format("M月D日")} {CommonBooking.strTotime(item.start_time)}～{CommonBooking.strTotime(item.end_time)}</div>
                          : <div className='col'>{moment(item.book_date).format("M月D日")}</div>}
                      </div>
                      {this.state.shoplist && <div className='row'>
                        <div className='col'>{this.state.shoplist.find(shop => Number(shop.shop_id) === Number(item.shop_id))?.shop_name}</div>
                      </div>}
                      <div className='row'>
                        <div className='col'>{item.category_name}</div>
                      </div>
                      {/* 予約内容確認 */}
                      {item.booking_status === constClass.STATUS.TREG &&
                        <div className='row'>
                          <div className='col'>仮予約</div>
                        </div>
                      }
                      {item.booking_status === constClass.STATUS.REG &&
                        <div className='row'>
                          <div className='col'>予約承認済</div>
                        </div>
                      }
                    </button>
                  </div>
                </div>
              ))}
            <hr />
            {/* 乗車済・キャンセル済みを直近5件まで表示*/}
            {this.state.bookingDetailList.filter(b => !(moment(b.book_date).isSameOrAfter(moment().format('YYYY-MM-DD')) && constClass.STATUS_NFIN.includes(b.booking_status))
              && moment(b.book_date).isAfter(moment().subtract(1, "month").format('YYYY-MM-DD'))//1ヶ月前まで表示
              && (b.booking_status !== constClass.STATUS.CUPAY) // キャンセル未決済は一覧に表示しない
            )
              .sort((b, a) => (moment(`${a.book_date} ${CommonBooking.strTotime(a.start_time)}`, 'YYYY-MM-DD k:mm').format('YYYYMMDDkkmm') - moment(`${b.book_date} ${CommonBooking.strTotime(b.start_time)}`, 'YYYY-MM-DD k:mm').format('YYYYMMDDkkmm'))) //予約済み・事前通知済み以外
              //.slice(0, 5)
              .map((item, idx) => (
                <div className="row mx-0 my-3 text-center" key={`${idx}`}>
                  <div className="col px-0">
                    <button
                      onClick={async (e) => { this.submitCurrentbooking(item.book_id, item.book_set_id, (moment(item.book_date).format('YYYYMMDD') === moment().format('YYYYMMDD') && item.booking_status === constClass.STATUS.FIN) ? constClass.RECEPT : constClass.CHANGECONFIRM); }}
                      className={`btn btn-secondary w-100 h-100 py-2 px-2`}>
                      <div className='row'>
                        <div className='col'>受付番号：{item.t_booking.receipt_num}</div>
                      </div>
                      <div className='row'>
                        {(item.start_time || item.end_time) ?
                          <div className='col'>{moment(item.book_date).format("M月D日")} {CommonBooking.strTotime(item.start_time)}～{CommonBooking.strTotime(item.end_time)}</div>
                          : <div className='col'>{moment(item.book_date).format("M月D日")}</div>}
                      </div>
                      <div className='row'>
                        <div className='col'>{item.category_name}</div>
                      </div>
                      {((constClass.STATUS.CPRE === item.booking_status || constClass.STATUS_PRE.includes(item.booking_status)) && !item.booking_status === constClass.STATUS.TREG) &&
                        <div className='row'>
                          <div className='col'>未受付</div>
                        </div>
                      }
                      {item.booking_status === constClass.STATUS.FIN &&
                        <div className='row'>
                          <div className='col'>来店済</div>
                        </div>
                      }
                      {constClass.STATUS_CCL.includes(item.booking_status) &&
                        <div className='row'>
                          <div className='col'>キャンセル済</div>
                        </div>
                      }
                    </button>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }

  renderFinish() {
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col px-0">
          <div id="bookfinish">
            <div className="row mx-0 pt-5 pb-5 bg-white">
              <div className='col text-center'>
                <h5>ご予約ありがとうございました。</h5>
              </div>
            </div>
            <div className="row mx-0 px-3-env py-2 bg-green text-white">
              <div className='col font-weight-bold text-center'>ご予約情報の確認・変更はこちら</div>
            </div>
            <div className="row mx-0 pt-2 pb-1 bg-white">
              <div className='col text-center'>
                <div className="row mx-0 my-3 text-center">
                  <div className="col px-0">
                    <button
                      onClick={e => this.submitCurrentbooking(null, null, constClass.HISTORY)}
                      className={`btn btn-primary w-100 h-100 py-2 px-2`}>
                      <h4 className="mb-0 font-weight-bold">ご予約履歴・変更</h4>
                    </button>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderReceptQr() {
    return (
      <div className="row mx-3 my-3 px-0-env">
        <div className="col p-1">
          <BookingQRRead
            siteId={this.props.siteId}
            lineId={this.props.liff_access_token}
            book_id={this.props.current_bookId}
            book_set_id={this.props.current_bookSetId}
            category_id={this.props.current_categoryId}
            settings={this.props.settings}
            page={this.props.page}
            recept={this.state.recept}
            getReceptdata={this.getReceptdata}
            submitCurrentbooking={this.submitCurrentbooking}
          />
        </div>
      </div>
    );
  }

  historyBack() {
    if (this.props.history.length <= 1 || [constClass.HISTORY, constClass.FINISH, constClass.RECEPT].includes(this.props.page)) {
      this.submitCurrentbooking(null, null, null);
    } else {
      if (this.props.page === constClass.CHANGECONFIRM && this.state.booking.book_id) {
        this.setState({ change: false });
        this.submitCurrentbooking(null, null, constClass.HISTORY);
      } else {
        //データ変更を取り消す
        this.setState({
          booking: { ...this.state.set_booking },
          booking_detail: this.state.set_booking_detail.concat(),
          bookCalList: this.state.set_bookCalList,
          bookCalListMessage: this.state.set_bookCalListMessage,
        });
        this.props.history.goBack();
      }
    }
    this.scrollPageTop();
  }

  renderBottom() {
    const Historybackbutton = (h) => {
      return (
        <div className="col-4 text-center p-0">
          <div className='py-2 px-2 p-env-bottom'>
            <button
              className={`btn btn-active w-100 py-2`}
              onClick={e => this.historyBack()}>
              戻る
            </button>
          </div>
        </div>
      )
    }

    const HistorynextButton = () => {
      var disabled = false;
      var nextpage = null;
      if (this.checkInvalid()) disabled = true;
      switch (this.props.page) {
        case constClass.USER:
          nextpage = this.state.change ? constClass.CHANGECONFIRM : constClass.CONFIRM;
          break;
        case constClass.INPUTALERT:
          nextpage = this.state.change ? constClass.CHANGECONFIRM : constClass.AREASELECT;
          break;
        case constClass.AREASELECT:
          nextpage = this.state.change ? constClass.CHANGECONFIRM : constClass.INPUT;
          break;
        case constClass.INPUT:
          nextpage = this.state.change ? constClass.CHANGECONFIRM : constClass.INPUTBIN1;
          break;
        case constClass.INPUTBIN1:
          nextpage = this.state.change ? constClass.CHANGECONFIRM : constClass.USER;
          break;
        default:
          return '';
      }
      return (
        <div className="col-8 text-center p-0">
          <div className='py-2 px-2 p-env-bottom'>
            <button
              disabled={disabled}
              className={`btn btn-active w-100 py-2`}
              onClick={() => {
                this.setState({
                  set_booking: { ...this.state.booking },
                  set_booking_detail: this.state.booking_detail.concat(),
                  set_bookCalList: this.state.bookCalList,
                  set_bookCalListMessage: this.state.bookCalListMessage
                });
                this.props.history.push(`/${this.state.siteId}/?page=${nextpage}`);
                this.scrollPageTop();
              }}>
              次へ
            </button>
          </div>
        </div>
      )
    }

    return (
      <footer className="footer text-center">
        <div className="container m-0 p-0 mw-100 bg-white border-top-3 border-green">
          <div className="row mx-0 ">
            <div className="col text-center p-0">
              <div className="row mx-0">
                {![constClass.MENU, constClass.PAYMENT].includes(this.props.page) &&
                  <Historybackbutton />
                }
                <HistorynextButton />
                {(this.props.page === constClass.CONFIRM || (this.props.page === constClass.CHANGECONFIRM && this.state.change)) &&
                  <div className="col-8 text-center p-0">
                    <div className='py-2 px-2 p-env-bottom'>
                      <button
                        disabled={this.state.disabled || this.state.booking_detail.find(x => x.errcheck && x.errcheck !== null)}
                        className={`btn btn-active w-100 py-2`}
                        onClick={() => { this.submit() }}>
                        次へ
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </footer >
    );
  }

  render() {
    return (
      this.state.sleeping ?
        <div className="liff-top">
          <div className="full-noheader" ref={this.pageRef}>
            <div className="row mx-0">
              <div className="col py-4 text-center">
                <img className='w-50' src={`/${this.props.siteId}/ct__main.svg`} alt="booking" onError={(e) => { e.target.onerror = null; e.target.style.display = 'none'; }} />
              </div>
            </div>
            <div className='text-center py-3'>
              {(!(window.liff.isInClient()) && (this.props.settings && "API_LIFF_URL" in this.props.settings)) ?
                <div className="row mx-3 mt-3 mb-3 text-center">
                  <div className="col px-0">
                    <button
                      onClick={e => window.location.replace(this.props.settings.API_LIFF_URL)}
                      className={`btn btn-primary w-100 h-100 py-3 px-2`}>
                      <div className='row m-0 p-0'>
                        <div className='col m-0 p-0 text-center align-self-center'><span className="mb-0 h5 font-weight-bold">LINEで開く</span></div>
                      </div>
                    </button>
                  </div>
                </div>

                : <h5 className='text-white'>{Common.getSettingValue(this.props.settings, "STOP_MESSAGE", "サービス停止中です")}</h5>
              }
            </div>
          </div>
        </div>
        :
        this.state.ready ?
          <div className={`liff-top ${(this.props.page === undefined || this.props.page === null || this.props.page === '' || this.props.page === constClass.MENU) ? "" : "bg-lightgreen"}`}>
            <ScrollToTop />
            <React.Fragment>
              {!(this.props.page === undefined || this.props.page === null || this.props.page === '' || this.props.page === constClass.MENU) && this.renderHeader()}
              <div className={`page-${(this.props.page === undefined || this.props.page === null || this.props.page === '' || this.props.page === constClass.MENU) ? 'full-noheader' : (this.props.page === constClass.PAYMENT) ? 'full' : 'btn'}`} ref={this.pageRef}>
                {(this.props.page === undefined || this.props.page === null || this.props.page === '' || this.props.page === constClass.MENU) &&
                  this.renderMenu()
                }
                {(this.props.page === constClass.USER) &&
                  this.renderUser()
                }
                {(this.props.page === constClass.INPUTALERT) &&
                  this.renderInputAlert()
                }
                {(this.props.page === constClass.INPUT) &&
                  this.renderInputCount()
                }
                {(this.props.page === constClass.AREASELECT) &&
                  this.renderArea()
                }
                {(this.props.page === constClass.INPUTBIN1) &&
                  this.renderInputBin()
                }
                {(this.props.page === constClass.CONFIRM || this.props.page === constClass.CHANGECONFIRM) &&
                  this.renderConfirm()
                }
                {this.props.page === constClass.PAYMENT &&
                  this.renderPayment()
                }
                {this.props.page === constClass.FINISH &&
                  this.renderFinish()
                }
                {this.props.page === constClass.HISTORY &&
                  this.renderBookSelect()
                }
                {(this.props.page === constClass.RECEPTQR || this.props.page === constClass.RECEPT) &&
                  this.renderReceptQr()
                }
                {this.props.page === constClass.CANCEL &&
                  <BookingCancel {...this.props} {...{ refreshBookData: this.refreshBookData, shop_id: this.state.booking.shop_id, shoplist: this.state.shoplist }} />
                }
              </div>
              {!(this.props.page === undefined || this.props.page === null || this.props.page === '' || this.props.page === constClass.MENU || this.props.page === constClass.PAYMENT) &&
                this.renderBottom()
              }
              {this.state.disabled && <Loading />}
            </React.Fragment>
          </div>
          : <Loading />)
  }

}

export default withRouter(Booking);